<template>
  <q-form
    ref="formRef"
    v-bind="$attrs"
    @input="isDirty = true"
    @validation-error="onValidationError"
  >
    <slot />
  </q-form>
</template>

<script setup>
import { scroll } from 'quasar'
import { computed, onMounted, ref, toRaw } from 'vue'

const formRef = ref(null)
const formComponents = ref([])
const hasErrors = computed(() => formComponents.value?.some((v) => v.hasError))
const isDirty = ref(false)
const validate = (param) => formRef.value?.validate(param)
const resetValidation = () => formRef.value?.resetValidation()

defineExpose({
  hasErrors,
  isDirty,
  formRef,
  validate,
  resetValidation,
})

onMounted(() => {
  formComponents.value = formRef?.value.getValidationComponents().map((proxy) => toRaw(proxy))
})

const onValidationError = (ref) => scrollToElement(ref.$el)
const { getScrollTarget, setVerticalScrollPosition } = scroll

const scrollToElement = (el) => {
  const target = getScrollTarget(el)
  const offset = el.offsetTop
  const duration = 100
  setVerticalScrollPosition(target, offset, duration)
}
</script>
